import React from "react";
import { useLocation } from "react-router";

export default function usePages(page: string) {
  const { pathname } = useLocation();
  return pathname.includes(page);
}
